"use strict";

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];

    for (var o in n) {
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
  }

  return e;
},
    _createClass = function () {
  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var o = t[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  return function (e, t, n) {
    return t && o(e.prototype, t), n && o(e, n), e;
  };
}();

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var React = require("react"),
    PropTypes = require("prop-types");

function closeOnClick(e) {
  var t = (_inherits(n, React.Component), _createClass(n, [{
    key: "open",
    value: function value() {
      var e = this;
      this.setState({
        isOpen: !0
      }, function () {
        document.body.addEventListener("click", e.closeOnClick);
      });
    }
  }, {
    key: "close",
    value: function value(e) {
      var t = this;
      this.setState({
        isOpen: !1
      }, function () {
        document.body.removeEventListener("click", t.closeOnClick);
      }), e.stopPropagation();
    }
  }, {
    key: "toggle",
    value: function value(e) {
      e.stopPropagation(), e.preventDefault(), this.state.isOpen ? this.close(e) : this.open();
    }
  }, {
    key: "closeOnClick",
    value: function value(e) {
      this.ref.current && (e.target === this.ref.current || this.ref.current.contains(e.target) || (this.close(e), this.props.afterCloseOnClick && this.props.afterCloseOnClick()));
    }
  }, {
    key: "render",
    value: function value() {
      return React.createElement(e, _extends({}, this.props, this.state, {
        forwardedRef: this.ref,
        isOpen: this.state.isOpen,
        toggle: this.toggle,
        open: this.open,
        close: this.close
      }));
    }
  }]), n);

  function n(e) {
    _classCallCheck(this, n);

    var t = _possibleConstructorReturn(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));

    return t.state = {
      isOpen: !!e.isOpen
    }, t.open = t.open.bind(t), t.close = t.close.bind(t), t.toggle = t.toggle.bind(t), t.closeOnClick = t.closeOnClick.bind(t), t.ref = React.createRef(), t;
  }

  return t.propTypes = {
    isOpen: PropTypes.bool,
    afterCloseOnClick: PropTypes.func
  }, t.defaultProps = {
    isOpen: !1,
    afterCloseOnClick: null
  }, t;
}

module.exports = closeOnClick;